<template>
    <div v-if="config">
        <setting-card
            v-bind="binds"
            v-model:active="soBank"
            active-readonly
            :hidePrevious="true"
            @updateProfile="updateProfile()"
        >
        </setting-card>
    </div>
</template>

<script lang="ts">
import SettingCard from "../SettingCard.vue";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

const SoBankImg = require("../../../assets/img/settings-icons/sobank.png");

@Component({
    components: {
        SettingCard,
    },
    emits: ["updateProfile"],
})
export class SettingSoBank extends Vue {
    @Prop({ default: null }) config!: any;
    @Prop({ default: null }) JDCConnectionOnTest!: any;
    @Prop({ default: null }) JDCConnectionTestSuccess!: any;

    get binds() {
        return {
            title: "Récupération des relevés bancaires",
            partnerName: "SoBank",
            text: "Utilisez SoBank pour récupérer les relevés bancaires au format EBICS. Pour cela il faut activer bobbee dans le portail de SoBank",
            logo: SoBankImg,
        };
    }

    get soBank() {
        return this.config?.soBank || false;
    }

    updateProfile() {
        this.$emit("updateProfile");
    }

    validCategory = ["ALL", "BANK"];

    searchCondition(search: string) {
        return (
            this.binds.title.toLowerCase().includes(search.toLowerCase()) ||
            this.binds.partnerName.toLowerCase().includes(search.toLowerCase()) ||
            this.binds.text.toLowerCase().includes(search.toLowerCase())
        );
    }

    displayCondition(
        search = "",
        tab: "ALL" | "BANK" | "MAIL" | "INVOICE" | "PAYEMENT" | "OTHER" = "ALL"
    ) {
        if (search) {
            return this.validCategory.includes(tab) && this.searchCondition(search);
        }
        return this.validCategory.includes(tab);
    }
}

export default toNative(SettingSoBank);
</script>
